/*
 * hellopanda-scrollto
 */
const HELLOPANDA_SCROLLTOGGLE = {
  lastScrollY: 0,
  ticking: false,
  scrollRecords: [],
  init: function() {
    const _ = this;
    document.addEventListener('DOMContentLoaded', function () {
      _.lastScrollY = window.scrollY;
      window.addEventListener('scroll', () => _.onScroll());
    });
  },

  onScroll: function () {
    const _ = this;
    if (!_.ticking) {
      window.requestAnimationFrame(function () {
        _.detect_scroll_toggle();
        _.ticking = false;
      });
      _.ticking = true;
    }
  },

  detect_scroll_toggle: function () {
    const _ = this;
    const currentScroll = window.scrollY;
    const direction = currentScroll > _.lastScrollY ? 'down' : 'up';
    const containers = document.querySelectorAll('.wp-block-hellopanda-scrolltoggle-block');
    containers.forEach((container, index) => {
      const trigger = container.dataset.trigger;
      const start = container.dataset.start || '';
      const sense = parseInt(container.dataset.sense || '0', 10);
      const topdelay = parseInt(container.dataset.topdelay || '0', 10);

      if (currentScroll < topdelay) {
        container.classList.add('is-scroll-top');
      } else {
        container.classList.remove('is-scroll-top');
      }

      if (this.scrollRecords[index] === undefined) {
        this.scrollRecords[index] = {
          active: start === 'start-show' ? true : false,
          direction: '',
          scroll: currentScroll,
          scrolled: false
        }
      }

      if (trigger === 'scroll-down' && direction === 'down') {

        if (this.scrollRecords[index].scroll + sense < currentScroll || !this.scrollRecords[index].scrolled) {
          container.classList.add('is-scroll');
          this.scrollRecords[index] = {
            active: true,
            direction: 'down',
            scroll: currentScroll
          }
        } else if (this.scrollRecords[index].active && this.scrollRecords[index].direction === 'down') {
          this.scrollRecords[index].scroll = currentScroll;
        }

      } else if (trigger === 'scroll-up' && direction === 'up') {

        if (this.scrollRecords[index].scroll - sense > currentScroll || !this.scrollRecords[index].scrolled) {
          container.classList.add('is-scroll');
          this.scrollRecords[index] = {
            active: true,
            direction: 'up',
            scroll: currentScroll
          }
        } else if (this.scrollRecords[index].active && this.scrollRecords[index].direction === 'up') {
          this.scrollRecords[index].scroll = currentScroll;
        }

      } else {

        if (trigger === 'scroll-up' && this.scrollRecords[index].scroll + sense < currentScroll) {
          container.classList.remove('is-scroll');
          this.scrollRecords[index].active = false;
          this.scrollRecords[index].scroll = currentScroll;
        } else if (trigger === 'scroll-down' && this.scrollRecords[index].scroll - sense > currentScroll) {
          container.classList.remove('is-scroll');
          this.scrollRecords[index].active = false;
          this.scrollRecords[index].scroll = currentScroll;
        }

        if (this.scrollRecords[index].active && this.scrollRecords[index].scrolled) {
          this.scrollRecords[index].active = false;
        }

      }

      container.classList.add('is-scrolled');
      this.scrollRecords[index].scrolled = true;
    });
    _.lastScrollY = currentScroll;
  },
};
HELLOPANDA_SCROLLTOGGLE.init();